import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const SpecialNoteListState = Immutable.fromJS({
	orderId: '',
	specialNoteList: [],
	activePage: 1,
	itemPerPage: 10,
	totalPage: 1
});

const specialNoteListReducer = handleActions({

	FIND_SPECIAL_NOTE_LIST: (state, { payload }) => {
		return state.merge({
			specialNoteList: payload.data.dataTableData,
			activePage: payload.data.activePage,
			totalPage: payload.data.totalPage,
			itemPerPage: payload.data.itemPerPage,
		})
	},
	CHANGE_SPECIAL_NOTE_ACTIVE_PAGE: (state, { payload }) => {
		return state.merge({
			activePage: payload.activePage,
			itemPerPage: payload.itemPerPage
		})
	}
}, SpecialNoteListState);

export default specialNoteListReducer;


// WEBPACK FOOTER //
// ./src/reducers/specialNoteListReducer.js